import React from 'react';
import useIsMobile from '@/hooks/useIsMobile';
import useDashboard, { WebsiteStatisticProvider, useWebsiteStattistic } from './useDashboard';
import DashboardDesktop from './desktop';
import DashboardMobile from './mobile';

const WebsiteStatisticWrap = () => {
  const isMobile = useIsMobile(992);
  const viewModel = useDashboard(isMobile);
  console.log('viewModel', isMobile);

  return (
    <WebsiteStatisticProvider value={viewModel}>
      {isMobile ? (
        <DashboardMobile viewModel={viewModel} />
      ) : (
        <DashboardDesktop viewModel={viewModel} />
      )}
    </WebsiteStatisticProvider>
  );
};

export { useWebsiteStattistic };
export default WebsiteStatisticWrap;